import { useEffect } from 'react';
import { DEFAULT_LANGUAGE_KEY, SUPPORTED_LANGUAGES } from '../constants';
import {
    getValidLanguageCode,
    localStorageService,
} from '../../shared';
import { useManageLanguage } from './useManageLanguage';

export function useInitLanguage(machineLanguageCode?: string) {
    const { onLanguageChange } = useManageLanguage();

    useEffect(() => {
        // 1. Check LocalStorage
        const storedLang = localStorageService.getItem('LANGUAGE');
        if (storedLang && SUPPORTED_LANGUAGES.includes(storedLang)) {
            onLanguageChange(storedLang, false);
            return;
        }

        // 2. Check Browser Language
        const browserLangFull =
            navigator.language || navigator.languages?.[0] || '';
        const browserLang = browserLangFull.split('-')[0]; // Convert "en-US" -> "en"
        const validBrowserLang = getValidLanguageCode(browserLang);

        if (
            validBrowserLang &&
            SUPPORTED_LANGUAGES.includes(validBrowserLang)
        ) {
            // 2.2) We support it: Save to LocalStorage and apply
            onLanguageChange(validBrowserLang);
            return;
        }

        // 3. Check machine Language
        if (machineLanguageCode) {
            const validMachineLang = getValidLanguageCode(machineLanguageCode);
            if (
                validMachineLang &&
                SUPPORTED_LANGUAGES.includes(validMachineLang)
            ) {
                // 3.2) Apply it, but DO NOT save to LocalStorage
                onLanguageChange(validMachineLang, false);
                return;
            }
        }

        // 4. Default Language (English)
        onLanguageChange(DEFAULT_LANGUAGE_KEY);
    }, [machineLanguageCode, onLanguageChange]);
}
